<div class="wrap">
  <div class="wrap__container">
    <div class="container">
      <div class="container__section container__section_message">
        <p class="message message_button">法人等からのお問い合わせは以下のページをご覧いただき、お問い合わせください</p>
      </div>
      <div class="container__section container__section_button">
        <app-button
          size="xl"
          (buttonClick)="routing.goToCollaboration()"
          [fullWidth]="true"
        >法人向けサービス</app-button>
      </div>
    </div>
  </div>
</div>
